module.exports = __webpack_public_path__ + "static/media/10.159d0628.png";